module.exports = __webpack_public_path__ + "static/media/NFTY.860a437b.png";